import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";

function ApplyFunctionsDialog({
  open,
  onCancel,
  onConfirm,
  columnTransforms,
}) {
  const formatArg = (arg) => {
    if (!arg) return "";

    /*
     * Column argument
     */
    if (arg.type === "column") {
      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "2px 7px",
            marginRight: "4px",
            borderRadius: "4px",
            backgroundColor: "#eff6ff",
            color: "#2563eb",
            fontWeight: 500,
            fontSize: "12px",
          }}
        >
          Column: {arg.value || "-"}
        </span>
      );
    }

    /*
     * Normal value argument
     */
    if (arg.type === "value") {
      let value = arg.value ?? "";

      /*
       * Remove the extra quotes used internally,
       * e.g.
       *
       * "\"[A-DC-]\"" -> [A-DC-]
       * "\"\""        -> ""
       */

      if (
        typeof value === "string" &&
        value.length >= 2 &&
        value.startsWith('"') &&
        value.endsWith('"')
      ) {
        value = value.slice(1, -1);
      }

      /*
       //Show empty string explicitly.

      if (value === "") {
        return (
          <span
            style={{
              color: "#6b7280",
              fontStyle: "italic",
            }}
          >
            empty string
          </span>
        );
      }
       */

      return (
        <span
          style={{
            display: "inline-block",
            padding: "2px 6px",
            marginRight: "4px",
            borderRadius: "4px",
            backgroundColor: "#f3f4f6",
            color: "#374151",
            fontFamily: "monospace",
            fontSize: "12px",
          }}
        >
          "{value}"
        </span>
      );
    }

    /*
     * Fallback
     */
    return (
      <span>
        {arg.value ?? "-"}
      </span>
    );
  };

  const rows = Object.entries(
    columnTransforms || {}
  ).flatMap(
    ([col, transforms]) =>
      (transforms || [])
        .filter(
          (t) =>
            t.fn !== null &&
            t.fn !== undefined &&
            t.fn !== ""
        )
        .map((t, i) => ({
          col,
          fn: t.fn,
          newCol: t.newCol,
          index: i,
          args: t.args || [],
        }))
  );

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        Confirm Apply Functions
      </DialogTitle>

      <DialogContent>
        {rows.length === 0 ? (
          <p
            style={{
              color: "#6b7280",
            }}
          >
            No functions selected.
          </p>
        ) : (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "13px",
            }}
          >
            <thead>
              <tr>
                <th
                  align="left"
                  style={{
                    padding: "8px",
                    borderBottom:
                      "1px solid #e5e7eb",
                  }}
                >
                  Function
                </th>

                <th
                  align="left"
                  style={{
                    padding: "8px",
                    borderBottom:
                      "1px solid #e5e7eb",
                  }}
                >
                  Source Column
                </th>

                <th
                  align="left"
                  style={{
                    padding: "8px",
                    borderBottom:
                      "1px solid #e5e7eb",
                  }}
                >
                  Arguments
                </th>

                <th
                  align="left"
                  style={{
                    padding: "8px",
                    borderBottom:
                      "1px solid #e5e7eb",
                  }}
                >
                  New Column
                </th>
              </tr>
            </thead>

            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td
                    style={{
                      padding: "8px",
                      verticalAlign: "top",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                      }}
                    >
                      {r.fn}
                    </span>
                  </td>

                  <td
                    style={{
                      padding: "8px",
                      verticalAlign: "top",
                    }}
                  >
                    {r.col}
                  </td>

                  <td
                    style={{
                      padding: "8px",
                      verticalAlign: "top",
                    }}
                  >
                    {r.args &&
                    r.args.length > 0 ? (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "4px",
                        }}
                      >
                        {r.args.map(
                          (arg, argIndex) => (
                            <span key={argIndex}>
                              {formatArg(arg)}
                            </span>
                          )
                        )}
                      </div>
                    ) : (
                      <span
                        style={{
                          color: "#9ca3af",
                        }}
                      >
                        -
                      </span>
                    )}
                  </td>

                  <td
                    style={{
                      padding: "8px",
                      verticalAlign: "top",
                    }}
                  >
                    {r.newCol || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={rows.length === 0}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ApplyFunctionsDialog;
